const CONSTANTS = {
  privacyPolicy: "Privacy Policy",
};

export default CONSTANTS;